export default __webpack_public_path__ + "static/media/q.8c1d544e.svg";